import React,{useState} from "react";

// MUI Components:
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Box     from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";

// Styled comp:
import { styled } from '@mui/material/styles';

/******************************************************
 * Component Style
******************************************************/

    const SectionTitle = styled(Typography) ({
        width:'100%',
        fontWeight:'bold',
        marginBottom:'0.3rem'
    });
    const ControlLabel = styled(Typography) ({
        width:'100%'
    });

    const CustTextFld =  styled(TextField) ({
        width:'100%',
        size:'small'
    });

    const InputContainer = styled(FormControl) ({
        width:'100%',
        [`& ${ControlLabel}`]: ({}),
        [`& ${CustTextFld}`]: ({})
        
        })
    
    const SectionContainer =  styled(Box)({
        width:'100%',
        marginTop:'1rem',
        marginBottom:'1rem',
        [`& ${InputContainer}`]: ({})
    })

function ContactView({handleChange, oEntry}) {

    const onContactChange = (oEvent, sParam) => {
        handleChange(oEvent,sParam);
    }

    return(
            <SectionContainer>
                <SectionTitle variant="h5">Contact Details</SectionTitle>
                <Grid container rowSpacing={1} columnSpacing={{ xs:2, sm:2, md: 2 }} disableGutters>

                    <Grid size={{xs:12, sm:6,  md:6, lg:6}}>
                        <InputContainer>
                            <ControlLabel>Full Name</ControlLabel>
                            <CustTextFld
                                key="crt_fullname"
                                // value={oEntry.contactName}
                                value={oEntry['contact']['contactName']}
                                onChange={ (oEvent) => onContactChange(oEvent, 'contactName') }
                                name="contact" 
                                type="text"
                                size="small"/>
                        </InputContainer>
                    </Grid>

                    <Grid size={{xs:12, sm:6,  md:6, lg:6}}>
                        <InputContainer>
                            <ControlLabel>Phone</ControlLabel>
                            <CustTextFld
                                key="crt_phone"
                                value={oEntry['contact']['phone']}
                                onChange={ (oEvent) => onContactChange(oEvent, 'phone') }
                                name="contact" 
                                type="Number"
                                size="small"/>
                        </InputContainer>
                    </Grid>

                    <Grid size={{xs:12, sm:6,  md:6, lg:6}}>
                        <InputContainer>
                            <ControlLabel>E-Mail</ControlLabel>
                            <CustTextFld
                                key="crt_email"
                                // value={contact.email}
                                value={oEntry['contact']['email']}
                                onChange={ (oEvent) => onContactChange(oEvent, 'email') }
                                name="contact" 
                                type="email"
                                size="small"/>
                        </InputContainer>
                    </Grid>
                </Grid>
            </SectionContainer>
    );
}

export default ContactView;